module.exports = __webpack_public_path__ + "img/Large-Horizontal-Rectangular-Attachment-37.21b6c437.png";